const collator = new Intl.Collator("en"); //This should change when we switch locales

function stringSort(a, b) {
   return collator.compare(a, b);
}

function reverseStringSort(a, b) {
   return collator.compare(b, a);
}

function numberSort(a, b) {
   return a - b;
}

function reverseNumberSort(a, b) {
   return b - a;
}

export { stringSort, numberSort, reverseStringSort, reverseNumberSort };
